import React, {useState} from "react";
import {useSelector} from "react-redux";
import Spinner from "../../components/Spinner/v1/Spinner";
import HamperShipped from "../../components/Verification/HamperVerification/HamperShipped";
import HamperVerification from "../../components/Verification/HamperVerification/HamperVerification";

const HamperValidate = (props) => {
    const hamperInfo = useSelector( (state) => state.customer.hampers );
    const [loading, setLoading] = useState( false );
    const [acknowledged, setAcknowledged] = useState( false );

    const handleAcknowledgement = () => {
        setAcknowledged( true );
    }

    if( hamperInfo?.[0]?.isVerified ) {
        props.success();
    }

    return (
        <>
            {loading && <Spinner />}
            <>
                { !acknowledged && <HamperShipped acknowledge={handleAcknowledgement} /> }
                { acknowledged && <HamperVerification screenType={props.screenType} setLoading={setLoading} /> }
            </>
        </>
    )
}

export default HamperValidate;
